module.exports = __webpack_public_path__ + "img/update.ad00b05f.svg";